import { Button, Collapse, H6 } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import classNames from 'classnames';
import * as React from 'react';

import { TEST_IDS } from 'src/constants/testIds';

export type CollapsibleBlockProps = {
  actions?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
  header: string;
  testId?: string;
};

export const COLLAPSED_CLASS = 'sd-collapsible-block-body--collapsed';

export const CollapsibleBlock: React.VFC<CollapsibleBlockProps> = ({
  actions,
  children,
  className,
  header,
  testId,
}) => {
  const [isOpen, setIsOpen] = React.useState(true);

  return (
    <div
      className={classNames('sd-collapsible-block', className)}
      data-testid={testId}
    >
      <div className="sd-collapsible-block-header">
        <H6 className="sd-collapsible-block-header-text">{header}</H6>
        <div className="sd-collapsible-block-header-right">
          {actions ? (
            <div className="sd-collapsible-block-header-right-actions">
              {actions}
            </div>
          ) : null}
          <Button
            className="sd-collapsible-block-header-right-collapse-button"
            data-testid={TEST_IDS.collapsibleBlock.collapseButton}
            icon={isOpen ? IconNames.CHEVRON_UP : IconNames.CHEVRON_DOWN}
            minimal
            onClick={() => setIsOpen(!isOpen)}
          />
        </div>
      </div>
      <Collapse isOpen={isOpen}>
        <div
          className="sd-collapsible-block-body"
          data-testid={TEST_IDS.collapsibleBlock.body}
        >
          {children}
        </div>
      </Collapse>
    </div>
  );
};
